const MEDIA_ITEMS = [
  {
    title: '庆余年 第二季',
    desc: '范闲归来，京都风云再起，全集高能不容错过',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20style%20with%20warm%20cinematic%20lighting%2C%20elegant%20composition%20with%20soft%20golden%20and%20coral%20tones%2C%20dramatic%20atmosphere%2C%20film%20poster%20aesthetic%20with%20artistic%20texture%2C%20no%20text%20or%20logos%2C%20luxurious%20warm%20color%20palette&width=800&height=1200&seq=media-01&orientation=portrait',
  },
  {
    title: '长相思',
    desc: '杨紫领衔古装虐恋，三王争一女，虐心又上头',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20drama%20poster%20style%20with%20ethereal%20warm%20golden%20lighting%2C%20flowing%20fabric%20textures%20in%20coral%20and%20amber%20tones%2C%20dreamy%20atmospheric%20composition%2C%20artistic%20cinematic%20aesthetic%2C%20no%20text%20or%20logos%2C%20soft%20romantic%20mood&width=800&height=1200&seq=media-02&orientation=portrait',
  },
  {
    title: '眼泪女王',
    desc: '金秀贤金智媛演绎豪门虐恋，韩剧年度高分之作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20style%20with%20elegant%20warm%20lighting%2C%20sophisticated%20composition%20with%20golden%20and%20rose%20gold%20tones%2C%20luxurious%20atmosphere%20with%20soft%20bokeh%2C%20cinematic%20romance%20aesthetic%2C%20no%20text%20or%20logos%2C%20moody%20emotional%20vibe&width=800&height=1200&seq=media-03&orientation=portrait',
  },
  {
    title: '与凤行',
    desc: '赵丽颖林更新古装仙侠，碧苍王与神君的旷世情缘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20xianxia%20drama%20poster%20style%20with%20celestial%20warm%20golden%20lighting%2C%20ethereal%20clouds%20and%20phoenix%20motifs%20in%20coral%20and%20amber%20hues%2C%20mythical%20atmospheric%20composition%2C%20no%20text%20or%20logos%2C%20heavenly%20dreamlike%20quality&width=800&height=1200&seq=media-04&orientation=portrait',
  },
  {
    title: '墨雨云间',
    desc: '复仇爽剧天花板，女主步步为营层层反转',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20drama%20poster%20style%20with%20moody%20warm%20lighting%2C%20ink%20wash%20painting%20inspired%20composition%20in%20charcoal%20and%20coral%20accents%2C%20mysterious%20atmospheric%20aesthetic%2C%20no%20text%20or%20logos%2C%20dramatic%20intense%20mood&width=800&height=1200&seq=media-05&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩预告</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            热门电视剧全集精彩看点速览，好剧一网打尽
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center gap-1.5">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                      <i className="ri-play-fill text-white text-sm"></i>
                    </div>
                    <span className="text-white text-xs">精彩看点</span>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-foreground-900 text-sm truncate group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}